import styled from 'styled-components';
import Box from '@mui/material/Box';
import Sidebar from "./Sidebar";
import { Outlet } from 'react-router-dom';

const ContainerBox = styled(Box)`
    height: 100%;
    min-height: 100vh; margin: 0px;
    position: relative;
    background: #F4F4F5;
`;
const SideBarContainer = styled(Box)`
    position: fixed;
    top: 0px;
    left: 0px;
    background: white;
    width: 235px;
    min-height: 100vh;
    z-index: 3;
`;

const Layout = () => {
    return (
        <ContainerBox>
            <SideBarContainer>
                <Sidebar />
            </SideBarContainer>
            <Box sx={{ marginLeft: "235px", minHeight: "100vh", overflowX: "auto", marginRight: "5px" }}>
                <Box sx={{ padding: "40px 20px 10px 20px", minWidth: "100%" }}>
                    <Outlet />
                </Box>
            </Box>
        </ContainerBox>
    )
}

export default Layout;